<template>
  <div>
    <v-card
      :outlined="$vuetify.breakpoint.lgAndUp"
      :flat="$vuetify.breakpoint.mdAndDown"
      class="results-options-card"
    >
      <!-- SMALL DEVICES CLOSE -->
      <v-btn
        v-if="$vuetify.breakpoint.mdAndDown"
        rounded
        depressed
        outlined
        color="white"
        small
        class="mt-3"
        @click="handleClickClose"
      >
        <v-icon
          color="primary"
          class="mr-1"
        >
          mdi-close-circle
        </v-icon>
        <span class="primary--text text-decoration-underline">Close</span>
      </v-btn>

      <!-- TITLE -->
      <v-card-title
        class="py-3"
      >
        Adjust Cover Options
      </v-card-title>

      <v-card-text>
        <!-- EDIT/SUMMARY BTNS -->
        <v-row dense>
          <v-col>
            <v-btn
              block
              outlined
              rounded
              color="primary"
              @click.prevent="onClickEditQuote"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-pencil
              </v-icon>
              <span class="caption font-weight-medium">Edit Quote</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              outlined
              rounded
              color="primary"
              @click="showQuoteDetails"
            >
              <span class="caption font-weight-medium">Quote Summary</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mt-3" />

        <!-- FILTERS -->
        <v-expansion-panels
          v-model="panelsShown"
          multiple
          accordion
          flat
        >
          <!-- PAYMENT TYPE -->
          <v-expansion-panel>
            <v-expansion-panel-header><strong>Payment Type</strong></v-expansion-panel-header>
            <v-expansion-panel-content v-scroll-to-viewport>
              <v-row dense>
                <v-col>
                  <v-btn
                    color="primary"
                    :outlined="!selectedFilters.isViewMonthly"
                    block
                    rounded
                    class="body-2"
                    @click="handleClickPaymentType(true)"
                  >
                    <v-icon
                      :size="20"
                      class="mr-1"
                    >
                      {{ selectedFilters.isViewMonthly ? '$radioOn' : '$radioOff' }}
                    </v-icon>
                    <span>Monthly</span>
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    color="primary"
                    :outlined="selectedFilters.isViewMonthly"
                    block
                    rounded
                    class="body-2"
                    @click="handleClickPaymentType(false)"
                  >
                    <v-icon
                      :size="20"
                      class="mr-1"
                    >
                      {{ !selectedFilters.isViewMonthly ? '$radioOn' : '$radioOff' }}
                    </v-icon>
                    <span>Annually</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
            <div
              v-show="!panelsShown.includes(0)"
              class="v-expansion-panel-content__wrap"
            >
              <p class="caption mb-0">
                {{ selectedFilters.isViewMonthly ? 'Monthly' : 'Annually' }}
              </p>
            </div>
            <v-divider />
          </v-expansion-panel>
          <template v-if="!isApricot">
            <!-- COVER TYPES -->
            <v-expansion-panel>
              <v-expansion-panel-header><strong>Cover Type</strong></v-expansion-panel-header>
              <v-expansion-panel-content v-scroll-to-viewport>
                <a
                  href="#"
                  class="caption"
                  @click.prevent="showCoverTypesDetails"
                >
                  What's the difference in cover types?
                </a>
                <v-select
                  v-model="coverType"
                  :items="options.typeOfCoverOptions"
                  outlined
                  dense
                  hide-details
                  attach
                  class="mt-2"
                />
              </v-expansion-panel-content>
              <div
                v-show="!panelsShown.includes(1)"
                class="v-expansion-panel-content__wrap"
              >
                <p class="caption mb-0">
                  {{ getCoverTypeString(coverType) }}
                </p>
              </div>
              <v-divider />
            </v-expansion-panel>

            <!-- VOLUNTARY EXCESS -->
            <v-expansion-panel>
              <v-expansion-panel-header><strong>Voluntary Excess</strong></v-expansion-panel-header>
              <v-expansion-panel-content v-scroll-to-viewport>
                <a
                  href="#"
                  class="caption"
                  @click.prevent="showExcessDetails"
                >
                  Excess, and how it effects my quote
                </a>

                <v-select
                  v-model="voluntaryExcess"
                  :items="options.voluntaryExcessOptions"
                  outlined
                  dense
                  hide-details
                  attach
                  class="mt-2"
                />
              </v-expansion-panel-content>
              <div
                v-show="!panelsShown.includes(2)"
                class="v-expansion-panel-content__wrap"
              >
                <p class="caption mb-0">
                  &pound;{{ voluntaryExcess }}
                </p>
              </div>
              <v-divider />
            </v-expansion-panel>

            <!-- PROTECT NCB -->
            <v-expansion-panel v-if="showProtectNcb">
              <v-expansion-panel-header><strong>Protect no claims</strong></v-expansion-panel-header>
              <v-expansion-panel-content v-scroll-to-viewport>
                <p class="body-2 mb-0">
                  Choose if you'd like to protect your no claims bonus or not.
                </p>
                <a
                  href="#"
                  class="caption"
                  @click.prevent="showNoClaimsDetails"
                >
                  No claims explained
                </a>

                <v-row
                  dense
                  class="mt-2"
                >
                  <v-col>
                    <v-btn
                      color="primary"
                      :outlined="!protectNcb"
                      block
                      rounded
                      class="body-2"
                      @click="handleProtectNcb(true)"
                    >
                      <v-icon
                        :size="20"
                        class="mr-1"
                      >
                        {{ protectNcb ? '$radioOn' : '$radioOff' }}
                      </v-icon>
                      <span>Yes please</span>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      :outlined="protectNcb"
                      block
                      rounded
                      class="body-2"
                      @click=" handleProtectNcb(false)"
                    >
                      <v-icon
                        :size="20"
                        class="mr-1"
                      >
                        {{ !protectNcb ? '$radioOn' : '$radioOff' }}
                      </v-icon>
                      <span>No thanks</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
              <div
                v-show="!panelsShown.includes(3)"
                class="v-expansion-panel-content__wrap"
              >
                <p class="caption mb-0">
                  {{ protectNcb ? 'Yes please' : 'No thanks' }}
                </p>
              </div>
              <v-divider />
            </v-expansion-panel>

            <!-- OPTIONAL EXTRAS -->
            <v-expansion-panel>
              <v-expansion-panel-header><strong>Optional Extras</strong></v-expansion-panel-header>
              <v-expansion-panel-content v-scroll-to-viewport>
                <p class="body-2 mb-0">
                  Additional extras to enhance your policy.
                </p>
                <a
                  href="#"
                  class="caption"
                  @click.prevent="showOptionalExtras"
                >
                  Learn more about optional extras
                </a>
                <v-checkbox
                  v-for="(extra, index) in options.optionalExtrasOptions"
                  :key="index"
                  v-model="optionalExtras"
                  :label="extra.label"
                  :value="extra.value"
                  hide-details
                  dense
                  class="mt-2 text-capitalize"
                  @change="handleOptionalExtras($event, extra.value)"
                />
              </v-expansion-panel-content>
              <div
                v-show="!panelsShown.includes(optionalExtrasPanelId)"
                class="v-expansion-panel-content__wrap"
              >
                <p
                  v-if="optionalExtras && optionalExtras.length > 0"
                  class="caption mb-0"
                >
                  <span
                    v-for="(extratitle, key) in optionalExtras"
                    :key="`${key}`"
                  >
                    {{ getOptionalExtrasTitle(extratitle) }}<span
                      v-if="key !== optionalExtras.length - 1"
                    >, </span>

                  </span>
                </p>
                <p
                  v-else
                  class="caption mb-0"
                >
                  Any
                </p>
              </div>
              <v-divider v-if="telematicsQuantity" />
            </v-expansion-panel>

            <!-- TELEMATICS -->
            <v-expansion-panel
              v-if="telematicsQuantity && !isApricot"
              :id="telematics"
            >
              <v-expansion-panel-header><strong>Telematics</strong></v-expansion-panel-header>
              <v-expansion-panel-content v-scroll-to-viewport>
                <p class="body-2 mb-0">
                  Telematics allows insurance companies to monitor your driving
                  through the use of a fitted device or app.
                </p>
                <a
                  href="#"
                  class="caption"
                  @click.prevent="showTelematicsDetails"
                >
                  More about telematics
                </a>
                <v-checkbox
                  v-for="(telematic, index) in options.telematicsOptions"
                  :key="`telematic-${index}`"
                  v-model="telematics"
                  :label="telematic.label"
                  :value="telematic.value"
                  hide-details
                  dense
                  class="mt-2 text-capitalize"
                  @change="handleTelematicsOptions($event, telematic.value)"
                />
              </v-expansion-panel-content>
              <div
                v-show="!panelsShown.includes(telematicsPanelId)"
                class="v-expansion-panel-content__wrap"
              >
                <p class="caption mb-0 text-capitalize">
                  {{ telematics && telematics.length > 0 ? telematics.join(', ') : 'None' }}
                </p>
              </div>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <!-- UPDATE QUOTE MODAL -->
    <v-card
      v-if="isUpdateQuoteShow"
      class="requote-message"
      elevation="2"
      light
    >
      <v-container
        fluid
        class="text-center d-flex flex-column justify-center align-center  pt-4"
      >
        <p
          class="mb-2 primary--text font-weight-medium"
        >
          Finished tailoring your policy?
        </p>
        <p
          class="body-2 mb-0 font-weight-medium"
        >
          When you’re done just click ‘Update Quotes’ to see your updated prices
        </p>
        <v-card-actions
          class="mt-6"
          style="width:100%;"
        >
          <v-btn
            x-large
            color="primary"
            rounded
            class="pl-4 pr-4"
            data-test="update_results_btn"
            @click="$emit('re-quote')"
          >
            <span>Update Quotes</span>
          </v-btn>
          <v-spacer />
          <v-btn
            x-large
            text
            rounded
            color="primary"
            data-test="cancel_btn"
            @click="$emit('cancel-re-quote', initialRequoteVal)"
          >
            <v-icon class="mr-1">
              $qz-close
            </v-icon>
            <span>Cancel</span>
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'results-options',
  inject: [
    'constants',
    'config',
    'productName',
  ],
  props: {
    formData: {
      type: Object,
      required: false,
      default: () => {},
    },
    options: {
      type: Object,
      required: true,
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: false,
      default: () => {},
    },
    isUpdateQuoteShow: {
      type: Boolean,
      default: false,
    },
    telematicsQuantity: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    panelsShown: [],
    initialRequoteVal: {},
  }),
  mounted () {
    this.initialRequoteVal = {
      typeOfCover: this.formData.cover.typeOfCover,
      voluntaryExcess: this.formData.cover.voluntaryExcess,
      protectBonus: this.formData.cover.protectBonus,
    };
  },
  created () {
    // depends on showProtectNcb change opened panels
    if (this.showProtectNcb) {
      this.panelsShown = [0, 2, 4];
    } else {
      this.panelsShown = [0, 2, 3];
    }
  },
  computed: {
    isApricot () {
      // this result options uses for three vehicle types, Apricot supports only two
      const SUPPORTED_APRICOT_PRODUCTS = ['car', 'van'];
      return SUPPORTED_APRICOT_PRODUCTS.includes(this.productName) && this.constants.PARTNERS.Apricot.includes(this.config.partner);
    },
    coverType: {
      get () {
        return this.formData && this.formData.cover.typeOfCover;
      },
      set (val) {
        this.internalTrackerResultsPage('coverType', this.constants.COVER_TYPE_OF_COVER[val]);
        this.$emit('change-requote-filter', { filter: 'typeOfCover', val });
      },
    },
    voluntaryExcess: {
      get () {
        return this.formData && this.formData.cover.voluntaryExcess;
      },
      set (val) {
        this.internalTrackerResultsPage('voluntaryExcess', val);
        this.$emit('change-requote-filter', { filter: 'voluntaryExcess', val });
      },
    },
    protectNcb: {
      get () {
        return this.formData && this.formData.cover.protectBonus;
      },
      set (val) {
        this.$emit('change-requote-filter', { filter: 'protectBonus', val });
      },
    },
    noClaimsBonus () {
      return this.formData && this.formData.cover.noClaimsBonus;
    },
    showProtectNcb: {
      get () {
        return typeof this.protectNcb !== 'undefined' && parseInt(this.noClaimsBonus) > 3;
      },
    },
    optionalExtras: {
      get () {
        return this.selectedFilters.optionalExtras;
      },
      set (value) {
        return this.$emit('change-filter', { filter: 'optionalExtras', value });
      },
    },
    telematics: {
      get () {
        return this.selectedFilters.telematics;
      },
      set (value) {
        return this.$emit('change-filter', { filter: 'telematics', value });
      },
    },
    optionalExtrasPanelId: {
      get () {
        // set index of optionalExtras panel based on status of ncb panel
        if (this.showProtectNcb) {
          return 4;
        }
        return 3;
      },
    },
    telematicsPanelId: {
      get () {
        // set index of telematics panel based on status of ncb panel
        if (this.showProtectNcb) {
          return 5;
        }
        return 4;
      },
    },
  },
  methods: {
    showQuoteDetails () {
      this.internalTrackerResultsPage('quoteSummary', true);
      this.$emit('click-details', ['details-quote-summary']);
    },
    showNoClaimsDetails () {
      this.$emit('click-details', ['details-description', 'noClaims']);
    },
    showTelematicsDetails () {
      this.$emit('click-details', ['details-description', 'telematics']);
    },
    showCoverTypesDetails () {
      this.$emit('click-details', ['details-description', 'coverTypes']);
    },
    showExcessDetails () {
      this.$emit('click-details', ['details-description', 'quoteExcess']);
    },
    showOptionalExtras () {
      this.$emit('click-details', ['details-description', 'optionalExtras']);
    },
    getOptionalExtrasTitle (key) {
      const optionalExtraTitle = this.detailsDescription.optionalExtras?.content.find((el) => el.slug === key);
      if (optionalExtraTitle) {
        return optionalExtraTitle.name;
      }
      return key;
    },
    getCoverTypeString (key) {
      return this.detailsDescription.coverTypes.content[key - 1]?.name;
    },
    onClickEditQuote () {
      this.internalTrackerResultsPage('editQuote', true);
      return this.$emit('click-edit-quote');
    },
    handleClickClose () {
      return this.$emit('click-close');
    },
    handleClickPaymentType (value) {
      this.internalTrackerResultsPage('paymentType', value ? 'Monthly' : 'Annually');
      return this.$emit('change-filter', { filter: 'isViewMonthly', value });
    },
    handleProtectNcb (value) {
      this.protectNcb = value;
      this.internalTrackerResultsPage('protectNoClaims', value);
    },
    handleOptionalExtras (selectedItems, value) {
      this.internalTrackerResultsPage(this.constants.OPTIONAL_EXTRAS_TRACKER_OPTIONS[value], selectedItems.includes(value));
    },
    handleTelematicsOptions (selectedItems, value) {
      this.internalTrackerResultsPage(this.constants.TELEMATICS_TRACKER_OPTIONS[value], selectedItems.includes(value));
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>

<style scoped lang="scss" src='@/assets/scss/results/results-options.scss'></style>
